import { createReducer } from '@reduxjs/toolkit';
import { initialState } from '../default';

import { getCampaignListWithTargetFiltering, getCustomerTargetFilters, getTimelineUserFilters, getUserCampaignList } from './actions';
import { UserCampaignListState } from './types';

export default createReducer(initialState as UserCampaignListState, builder => {
  builder
    .addCase(getUserCampaignList.pending, state => {
      state.pending = true;
    })
    .addCase(getUserCampaignList.fulfilled, (state, { payload }) => {
      state.pending = false;
      state.fullfilled = true;
      state.data = payload.data;
      state.lastRefreshDate = payload.lastRefresh;
    })
    .addCase(getUserCampaignList.rejected, state => {
      state.pending = false;
      state.error = true;
      state.lastRefreshDate = undefined;
    })
    .addCase(getCampaignListWithTargetFiltering.pending, state => {
      state.pending = true;
      state.targetFiltersApplied = false;
    })
    .addCase(getCampaignListWithTargetFiltering.fulfilled, (state, { payload }) => {
      state.pending = false;
      state.fullfilled = true;
      state.targetFiltersApplied = true;
      state.targetFilteredCampaigns = payload;
    })
    .addCase(getCampaignListWithTargetFiltering.rejected, state => {
      state.pending = false;
      state.error = true;
      state.targetFiltersApplied = false;
    })
    .addCase(getTimelineUserFilters.fulfilled, (state, { payload }) => {
      state.filters = payload;
    })
    .addCase(getCustomerTargetFilters.fulfilled, (state, { payload }) => {
      state.targetFilters = payload;
    });
});
